var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSortDescend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1.2em",
    height: "1.2em",
    viewBox: "0 0 19.564 19.62",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "b",
    "data-name": "Lfl046.tif"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m3.367,16.926c-.425-.412-.828-.809-1.24-1.195-.113-.106-.245-.205-.386-.265-.312-.134-.684-.014-.876.257-.208.293-.222.683.019.929.763.778,1.525,1.559,2.323,2.3.511.475,1.404.454,1.914-.028.765-.724,1.505-1.475,2.241-2.229.303-.31.275-.779-.022-1.069-.292-.285-.763-.292-1.072.005-.396.379-.778.772-1.165,1.161-.047.047-.083.106-.124.159l-.063-.023c0-.067,0-.133,0-.2,0-4.124,0-8.248,0-12.372,0-.975.002-1.949,0-2.924-.001-.429-.233-.732-.615-.817-.409-.091-.829.179-.905.59-.022.119-.027.242-.027.363-.001,5.038-.001,10.076-.001,15.113v.243Z",
    fill: "#666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13.091.59c-1.651,0-3.301,0-4.952,0-.449,0-.75.22-.842.607-.098.415.178.84.597.916.095.017.194.025.29.025,3.283.001,6.566,0,9.849.001.27,0,.524-.045.71-.264.207-.244.263-.519.133-.817-.134-.305-.384-.444-.706-.466-.121-.008-.244-.002-.365-.002-1.572,0-3.143,0-4.715,0Z",
    fill: "#666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.938,6.025c1.303,0,2.605,0,3.908,0,.312,0,.532-.152.673-.421.143-.274.112-.545-.064-.792-.141-.197-.334-.315-.587-.315-2.617,0-5.235,0-7.852.002-.41,0-.751.361-.744.769.006.407.339.753.741.755,1.309.004,2.617.001,3.926.002Z",
    fill: "#666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10.762,9.933c.889,0,1.779.002,2.668,0,.436-.001.737-.239.82-.634.083-.397-.196-.816-.595-.888-.095-.017-.193-.026-.29-.026-1.73-.001-3.46-.002-5.19,0-.466,0-.769.202-.87.573-.138.508.23.97.789.974.804.006,1.608.002,2.412.002.085,0,.171,0,.256,0Z",
    fill: "#666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9.602,12.287c-.506,0-1.011-.005-1.517.002-.337.005-.601.147-.743.466-.132.297-.074.572.131.817.161.192.381.261.619.262,1.005.004,2.01.005,3.015,0,.327-.002.592-.134.741-.442.135-.279.099-.547-.079-.792-.163-.223-.399-.311-.668-.312-.499-.002-.999,0-1.498,0Z",
    fill: "#666"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortDescend);
export default __webpack_public_path__ + "static/media/sort-descend.e8d0e4f6.svg";
export { ForwardRef as ReactComponent };